import entityTypes from 'maps/entity-types';
import allowedRelatedEntityTypes from 'maps/related-entity-types';
import { EntityTypes } from 'context/entityContext';

export default getAllowedRelatedEntities;

/**
 * This function takes an entityType as argument, and returns an array
 * of entities which are suitable as entityTypes in the 'browse related entities' component
 *
 * @param isExternalUser  Boolean indicating if the user is external (e.g. non-WMG)
 * @param entityType    The entityType you want to show related entities for
 * @returns entityTypes     Array of strings that are allowed entityTypes
 */
function getAllowedRelatedEntities(
  isExternalUser: boolean,
  entityType: EntityTypes
): any[] {
  const allowedEntityTypes = allowedRelatedEntityTypes[entityType];
  const allowedEntities = allowedEntityTypes.map(mapToLabelValue);

  if (isExternalUser) {
    return allowedEntities.filter(filterLabels);
  }

  return allowedEntities;
}

function mapToLabelValue(entityType: EntityTypes | 'version'): any {
  if (entityType === 'version') {
    return { value: 'version', label: 'Versions' };
  }

  return entityTypes.find((type) => type.value === entityType);
}

function filterLabels(entity: any): boolean {
  return entity.value !== 'label';
}
